import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The Slavic Esperanto",
  "description": "",
  "published": "2010-03-08T00:00:00.000Z",
  "redirect_from": ["/blog/the-slavic-esperanto/swizec/1237"],
  "categories": "intrigues, Linguistics, Slavic languages, Slovene language, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:ZographensisColour.jpg"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/03/300px-ZographensisColour.jpg",
              "alt": "Codex Zographensis in the Glagolitic alphabet ..."
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:ZographensisColour.jpg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`Sometimes when I'm out and about and not being careful about my clothing my penis slips out.`}</p>
    <p>{`No wait that's not right. My linguistic geek slips out.`}</p>
    <p>{`Yeah, that one! Linguistic geekdom! All over the place! Like a vulgar Andy Warhol rip off painted on a pornstar's fake boobs.`}</p>
    <p>{`So last time that happened it was because I stumbled upon something called a Slovianski Jezik, which is apparently something not unlike an `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Esperanto",
        "title": "Esperanto"
      }}>{`Esperanto`}</a>{` exclusively for slavic languages.`}</p>
    <p>{`Of course I went full monty on it and was all like "Omigosh omigosh this is liek SO brilliant yeah!?" in my best `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Cockney",
        "title": "Cockney"
      }}>{`cockney accent`}</a>{` impersonation.`}</p>
    <p>{`But the thing is that, all joking aside, us `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Slavic_peoples",
        "title": "Slavic peoples"
      }}>{`slavs`}</a>{` are in dire need of a language such as this. The most painful thing we have to deal with is that already, as it is, in our natural state, it's almost like we were talking dialects of the same language. Well not really, but still, there are many many similarities.`}</p>
    <p>{`Like I've read once that `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Slavic_languages",
        "title": "Slavic languages"
      }}>{`Slavic languages`}</a>{` are the only family of languages in the world where speakers talking to one another feel like the other person `}<em parentName="p">{`should`}</em>{` be understandable, but has such a horrible `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Speech_disorder",
        "title": "Speech disorder"
      }}>{`speech impediment`}</a>{` that they just can't quite make them out. Combined with regional differences in vocabulary and you're in a fucked up situation where you instinctively feel like you should be able to converse normally ...`}</p>
    <p>{`... but just can't.`}</p>
    <p>{`For example I went to `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=50.0833333333,14.4166666667&spn=0.1,0.1&q=50.0833333333,14.4166666667%20(Prague)&t=h",
        "title": "Prague"
      }}>{`Prague`}</a>{` last week. When there I could almost understand everything I saw in written language and could understand something like 50% of the things I was told. 70% when I tried really hard.`}</p>
    <p>{`But as soon as I tried to do some proper communication there was a big fail and we were all forced to default back to English, which is just horrible. Come on, a Slovenian and a Czech conversing in a stupid germanic language. EW!`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:AndyWarholBridgePittsburgh.JPG"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/03/300px-AndyWarholBridgePittsburgh.jpg",
              "alt": "The Andy Warhol Bridge (7th Street) Bridge in ..."
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:AndyWarholBridgePittsburgh.JPG"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`That's where Slovianski comes in. It is specifically designed to be instantly and intuitively intelligible to anyone who understands slavic languages, more specifically, anyone who is a Slav. You can try this on the `}<a parentName="p" {...{
        "href": "http://steen.free.fr/slovianski/"
      }}>{`Slovianski language front page`}</a></p>
    <p>{`Personally I can make out just about everything it says. Even when a word is missing I can very simply understand it from the context.`}</p>
    <p>{`This is without ever having learnt any other Slavic languages than Slovene and I guess I learned some Serbocroatian by ear simply from ... well those who know why know, the rest don't really have to know.`}</p>
    <p>{`I think every Slav out there should learn this language, I sure know I want to. It looks easy enough anyway.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/2835fdd5-913c-44aa-9cc0-aad198cf3470/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=2835fdd5-913c-44aa-9cc0-aad198cf3470",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      